import React, { Fragment, useContext, useEffect, useState } from "react";
import { English } from "../../../Constant";
import { useTranslation } from "react-i18next";
import { LI } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";

const LanguageClass = () => {
  const [langdropdown, setLangdropdown] = useState(false);
  const { i18n } = useTranslation();

  const [selected, setSelected] = useState(i18n.language);
  const { setLayoutDir ,layoutDirChange } = useContext(CustomizerContext);


  const changeLanguage = (lng) => {
    if (selected === lng) {
      return;
    }
    i18n.changeLanguage(lng);
 
    setSelected(lng);
    localStorage.setItem("i18nextLng",lng)
    if (selected === "ar") {
      document.body.classList.add("ltr");
      document.body.classList.remove("rtl");
      document.body.classList.remove("box-layout");
      document.documentElement.dir = "ltr";
      layoutDirChange("ltr");
    } else if (selected === "en") {
      document.body.classList.add("rtl");
      document.body.classList.remove("ltr");
      document.documentElement.dir = "rtl";
      document.body.classList.remove("box-layout");
      layoutDirChange("rtl");
    }
  };

  const LanguageSelection = (language) => {
    if (language) {
      setLangdropdown(!language);
    } else {
      setLangdropdown(!language);
    }
  };
  return (
    <Fragment>
      <LI attrLI={{ className: "onhover-dropdown" }}>
        <div className={`translate_wrapper ${langdropdown ? "active" : ""}`}>
          <div className="current_lang">
            <div
              className="lang d-flex"
              onClick={() => LanguageSelection(langdropdown)}>
              <i
                className={`flag-icon flag-icon-${
                  selected === "en" ? "us" : "kw"
                }`}></i>
              <span className="lang-txt">{selected}</span>
            </div>
          </div>
          <div
            className={`more_lang onhover-show-div ${
              langdropdown ? "active" : ""
            }`}>
            <div className="lang" onClick={() => changeLanguage("en")}>
              <i className="flag-icon flag-icon-us"></i>
              <span className="lang-txt">
                {English}
                <span> {"(US)"}</span>
              </span>
            </div>

            <div className="lang" onClick={() => changeLanguage("ar")}>
              <i className="flag-icon flag-icon-kw"></i>
              <span className="lang-txt">
                {"لعربية"}
                <span> {"(Kw)"}</span>
              </span>
            </div>
          </div>
        </div>
      </LI>
    </Fragment>
  );
};

export default LanguageClass;
